import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../helpers/model.helper';

export const TRACKING_EVENT_SCHEMA = Object.freeze({
  NAME: null,
  PROPERTIES: null,
});
const RECORD = generateSchema(TRACKING_EVENT_SCHEMA);
const KEYS: any = generateKeys(TRACKING_EVENT_SCHEMA);

export class TrackingEvent extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get properties(): string {
    return this.get(KEYS.PROPERTIES).toJS();
  }
}
